<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <!-- <h4 class="card-title">Πίνακας Παρουσιών Προσωπικού</h4> -->
            <!-- <div v-if="errorMsg">
              <b-alert show dismissible variant="danger">{{
                errorMsg
              }}</b-alert>
            </div> -->
            <!-- <p class="card-title-desc"></p> -->
            <div class="col-12">
              <div class="row">
                <div class="col-md-2">
                  <div class="mb-3">
                    <label class="mt-3">Από</label>
                    <b-form-input
                      id="example-input"
                      v-model="startDate"
                      type="date"
                      placeholder="DD-MM-YYYY"
                      format="DD-MM-YYYY"
                      autocomplete="off"
                    ></b-form-input>
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="mb-3">
                    <label class="mt-3">Μέχρι (Κενό: χθές)</label>
                    <b-form-input
                      id="example-input"
                      v-model="endDate"
                      type="date"
                      placeholder="DD-MM-YYYY"
                      format="DD-MM-YYYY"
                      autocomplete="off"
                    ></b-form-input>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="mb-2">
                    <label class="mt-3">Ονομα Χρήστη</label>
                    <multiselect
                      v-model="personOptionValue"
                      :options="peopleOptions"
                      track-by="id"
                      label="name"
                      placeholder="Επιλέξτε Χρήστη"
                      selectLabel="Eπιλογή Χρηση"
                      selectedLabel="Επιλέχθηκε"
                      deselectLabel="Αποεπιλογή"
                      :multiple="true"
                      :max="1"
                    ></multiselect>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xl-12">
              <div class="row">
                <div class="col-md-12">
                  <div class="mb-2">
                    <label>Τμήμα</label>
                    <multiselect
                      v-model="departmentValue"
                      :options="departmentNames"
                      track-by="id"
                      label="name"
                      placeholder="Επιλέξτε Τμήμα"
                      selectLabel="Eπιλογή Τμήματος"
                      selectedLabel="Επιλέχθηκε"
                      deselectLabel="Αποεπιλογή"
                      :max-height="200"
                    ></multiselect>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-12" style="margin-top:30px">
              <div class="row">
                <!-- End of -->
                <div class="table-responsive">
                  <table class="table mb-0">
                    <thead class="table-light">
                      <tr>
                        <th>Α/Α</th>
                        <th>Ονοματεπώνυμο</th>
                        <th>Τμήμα</th>
                        <th>Ωράριο</th>
                        <th>Ημερομηνία</th>
                        <th>Αφιξη</th>
                        <th>Αποχώρηση</th>
                        <th>Εντός ωραρίου</th>
                        <th>Συνολικές Ώρες</th>
                        <th>Παρατηρήσεις</th>
                      </tr>
                    </thead>

                    <tbody v-if="people && people.results">
                      <tr
                        v-for="(person, index) in people.results"
                        :key="index"
                      >
                        <th scope="row">
                          <!-- {{ index + 1 }} -->
                          {{
                            people.current_page * perPage - perPage + index + 1
                          }}
                        </th>

                        <td>{{ person.full_name }}</td>

                        <td>
                          {{ person.department_name }}
                        </td>
                        <td>
                          {{ trimWorkingSchedule(person.working_schedule) }}
                        </td>

                        <td>
                          {{
                            person.date
                              .split("-")
                              .reverse()
                              .join("-")
                          }}
                        </td>

                        <td
                          v-if="
                            person.attendances && person.attendances.length > 0
                          "
                        >
                          <!-- {{
                            person.attendances[0].timestamp
                              .split(" ")[0]
                              .split("-")
                              .reverse()
                              .join("-")
                          }} -->
                          {{ parseTimestamp(person.attendances[0].timestamp) }}
                          -
                          {{ person.attendances[0].device }}
                        </td>
                        <td
                          v-if="
                            person.attendances && person.attendances.length > 0
                          "
                        >
                          <!-- {{
                            person.attendances
                              .slice(-1)[0]
                              .timestamp.split(" ")[0]
                              .split("-")
                              .reverse()
                              .join("-")
                          }} -->
                          {{
                            parseTimestamp(
                              person.attendances.slice(-1)[0].timestamp
                            )
                          }}
                          -
                          {{ person.attendances.slice(-1)[0].device }}
                        </td>
                        <td>
                          {{ person.in_working_time }}
                        </td>
                        <td>{{ person.total_hours }}</td>
                        <td
                          v-if="person.public_holiday || person.is_on_holidays"
                        >
                          {{ person.public_holiday }} -
                          {{ person.is_on_holidays }}
                        </td>
                        <td v-else></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div class="row">
                  <div class="col">
                    <div
                      class="dataTables_paginate paging_simple_numbers float-end"
                    >
                      <ul
                        class="pagination pagination-rounded mb-0"
                        v-if="people.results"
                      >
                        {{
                          people.results.count
                        }}
                        <!-- pagination -->
                        <b-pagination
                          v-model="currentPage"
                          :total-rows="people.count"
                          :per-page="perPage"
                        ></b-pagination>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "../../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Multiselect from "vue-multiselect";
import { mapState, mapGetters } from "vuex";
import session from "../../../../api/session";
import moment from "moment";
export default {
  page: {
    title: "Παρουσιες προσωπικού",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, Multiselect },
  data() {
    return {
      title: "Παρουσιες προσωπικου",
      items: [
        {
          text: "Αρχική",
          to: { name: "home" },
        },
        {
          text: "Παρουσιες προσωπικού",
          active: true,
        },
      ],
      startDate: "",
      endDate: new Date(Date.now() - 864e5).toISOString().split("T")[0],
      departmentValue: "",
      personOptionValue: "",
      currentPage: 1,
      perPage: 15,
      people: [],
      peopleFilters: {
        currentPage: 1,
        department: "",
        startdate: "",
        enddate: "",
        person: "",
      },
    };
  },

  created() {
    this.fetchPeopleWorkingHours();
  },

  watch: {
    currentPage(value) {
      this.currentPage = value;
      this.fethPeoplewithFilters();
    },

    startDate(value) {
      this.startDate = value;
      this.currentPage = 1;
      this.fethPeoplewithFilters();
    },
    endDate(value) {
      this.endDate = value;

      this.currentPage = 1;
      this.fethPeoplewithFilters();
    },
    departmentValue(value) {
      this.departmentValue = value;
      this.currentPage = 1;
      this.fethPeoplewithFilters();
    },
    personOptionValue(value) {
      this.personOptionValue = value;
      this.currentPage = 1;
      this.fethPeoplewithFilters();
    },
  },
  computed: {
    ...mapGetters("auth", ["is_staff", "is_superuser"]),
    ...mapState("utils", [
      "departments",
      "peopleOptionFields",
      "departmentOptions",
    ]),
    // ...mapGetters("utils", ["departmentNames"]),
    departmentNames() {
      this.preFillDepartmentValue();
      return this.departmentOptions.map((e) => {
        return { id: e.id, name: e.department_parent_name };
      });
    },
    peopleOptions() {
      if (this.departmentValue && this.departmentValue.id) {
        return this.peopleOptionFields
          .filter((e) => {
            return e.department.includes(this.departmentValue.id);
          })
          .map((e) => {
            return { id: e.id, name: e.person_full_name };
          });
      } else {
        return this.peopleOptionFields.map((e) => {
          return { id: e.id, name: e.person_full_name };
        });
      }
    },
  },
  methods: {
    preFillDepartmentValue() {
      if (!(this.is_staff || this.is_superuser)) {
        this.departmentValue = this.departmentOptions.map(
          (e) => `${e.parent_name}/${e.name}`
        )[0];
      }
    },

    async fetchPeopleWorkingHours() {
      const data = {
        attendance_null: false,
        is_still_checked_in: false,
        end_date: this.endDate,
      };
      const urlparams = new URLSearchParams(data).toString();
      await session
        .get(`api/people/working-hours/?${urlparams}`)
        .then((resp) => {
          this.people = resp.data;
        });
    },

    async fethPeoplewithFilters() {
      const requestData = {
        attendance_null: false,
        is_still_checked_in: false,
        start_date: this.startDate ? this.startDate : "",
        end_date: this.endDate ? this.endDate : "",
        department:
          this.departmentValue && this.departmentValue.id > -1
            ? this.departmentValue.id
            : "",
        person:
          this.personOptionValue.length > 0 ? this.personOptionValue[0].id : "",
        page: this.currentPage,
      };

      const requestParams = new URLSearchParams(requestData).toString();

      await session
        .get(`api/people/working-hours/?${requestParams}`)
        .then((resp) => {
          this.people = resp.data;
        })
        .catch((e) => {
          console.log(e.response.data);
        });
    },
    trimWorkingSchedule(workerSchedule) {
      return workerSchedule
        .map((e) => {
          return `${this.parseScheduleTime(
            e.start_time
          )}-${this.parseScheduleTime(e.end_time)}`;
        })
        .join("\n");
    },
    parseTimestamp(timestamp) {
      return moment(timestamp).format("HH:mm:ss");
    },
    parseScheduleTime(scheduleTime) {
      return moment(scheduleTime, "HH:mm:ss").format("HH:mm");
    },
  },
};
</script>
